<template>
  <div id="pdf">
    <div id="pdfFile">
      <div
        style="
          position: absolute;
          left: 0;
          top: 0px;
          width: 595px;
          height: 842px;
          border-style: outset;
          border-color: white;
        "
      >
        <div style="position: absolute; left: 0px; top: 0px">
          <img
            src="@/assets/images/background1f.jpg"
            width="595"
            height="842"
          />
        </div>
        <!-- header -->
        <div
          style="position: absolute; left: 450px; top: 137px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ CapitalLetters.Date }}</span>
        </div>
        <div
          style="position: absolute; left: 162px; top: 133px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ RunningNumner }}</span>
        </div>
        <!-- End header -->
        <div
          style="position: absolute; left: 155px; top: 156px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Organisation }}</span>
        </div>
        <div
          style="
            position: absolute;
            left: 98px;
            top: 178px;
            font-size: 10px;
            width: 410px;
            line-height: 2.2;
          "
          class="cls_005"
        >
          <span class="cls_005">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;
            {{ Local.Address }}
          </span>
        </div>
        <div
          style="position: absolute; left: 165px; top: 226px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Local.Tel }}</span>
        </div>
        <div
          style="position: absolute; left: 375px; top: 226px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Local.Fax }}</span>
        </div>
        <div
          style="position: absolute; left: 120px; top: 250px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Email }}</span>
        </div>
        <div
          style="position: absolute; left: 345px; top: 250px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Website }}</span>
        </div>
        <div
          style="
            position: absolute;
            left: 95px;
            top: 272px;
            font-size: 10px;
            width: 410px;
            line-height: 2.2;
          "
          class="cls_005"
        >
          <span class="cls_005">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;
            {{ Bangkok.Address }}
          </span>
        </div>
        <div
          style="position: absolute; left: 165px; top: 320px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Bangkok.Tel }}</span>
        </div>
        <div
          style="position: absolute; left: 375px; top: 320px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Bangkok.Fax }}</span>
        </div>
        <div
          style="position: absolute; left: 198px; top: 342px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Represented.Name }}</span>
        </div>
        <div
          style="position: absolute; left: 115px; top: 365px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Represented.Title }}</span>
        </div>
        <div
          style="position: absolute; left: 375px; top: 365px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Represented.Tel }}</span>
        </div>
        <div
          style="position: absolute; left: 165px; top: 388px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Represented.Fax }}</span>
        </div>
        <div
          style="position: absolute; left: 332px; top: 388px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Represented.Email }}</span>
        </div>
        <div
          style="position: absolute; left: 210px; top: 423px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Alternate.Name }}</span>
        </div>
        <div
          style="position: absolute; left: 115px; top: 445px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Alternate.Title }}</span>
        </div>
        <div
          style="position: absolute; left: 375px; top: 445px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Alternate.Tel }}</span>
        </div>
        <div
          style="position: absolute; left: 165px; top: 469px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Alternate.Fax }}</span>
        </div>
        <div
          style="position: absolute; left: 332px; top: 469px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ Alternate.Email }}</span>
        </div>
        <div
          style="
            position: absolute;
            left: 95px;
            top: 488px;
            font-size: 10px;
            width: 410px;
            line-height: 2.3;
          "
          class="cls_005"
        >
          <span class="cls_005">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;
            {{ DescriptionServices }}
          </span>
        </div>
        <div
          style="
            position: absolute;
            left: 95px;
            top: 559px;
            font-size: 10px;
            width: 410px;
            line-height: 2.3;
          "
          class="cls_005"
        >
          <span class="cls_005">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;
            {{ ExperienceMICE }}
          </span>
        </div>
        <div
          style="
            position: absolute;
            left: 95px;
            top: 678px;
            font-size: 10px;
            width: 380px;
            line-height: 2.3;
          "
          class="cls_005"
        >
          <span class="cls_005">
            &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&ensp;&ensp;
            <span v-for="(item, key) in OAMembership" :key="key">
              {{ key + 1 }}.{{ item.name}}<span :class="key + 1 == OAMembershiplength ? 'd-none' : ''">,
              </span>
            </span>
          </span>
        </div>
      </div>
      <div
        style="
          position: absolute;
          left: 0;
          top: 838px;
          width: 595px;
          height: 842px;
          border-style: outset;
          border-color: white;
        "
      >
        <div style="position: absolute; left: 0px; top: 0px">
          <img
            src="@/assets/images/background2f.jpg"
            width="595"
            height="842"
          />
        </div>
        <div
          style="position: absolute; left: 210px; top: 150px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="
              MembershipCategory == '' || MembershipCategory == 'null'
                ? 'd-none'
                : ''
            "
          >
            {{ MembershipCategory }}
          </span>
        </div>
        <div
          style="position: absolute; left: 200px; top: 172px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="SubscriptionRate == '0' ? 'd-none' : ''"
          >
            {{ SubscriptionRate }}
          </span>
        </div>
        <div
          style="position: absolute; left: 250px; top: 194px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.NumberOfRooms == '0' ? 'd-none' : ''"
          >
            {{ ForHotelOnly.NumberOfRooms }}
          </span>
        </div>
        <!-- category 1 -->
        <div
          style="
            position: absolute;
            left: 132px;
            top: 235px;
            font-size: 10px;
            font-size: 18px !important;
          "
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '0' ? '' : 'd-none'"
          >
            <i><b>/</b></i>
          </span>
        </div>
        <div
          style="position: absolute; left: 405px; top: 261px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '0' ? '' : 'd-none'"
          >
            {{ ForHotelOnly.TotalBaht }}
          </span>
        </div>
        <!-- End category 1 -->

        <!-- category 2 -->
        <div
          style="
            position: absolute;
            left: 132px;
            top: 283px;
            font-size: 10px;
            font-size: 18px !important;
          "
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '1' ? '' : 'd-none'"
          >
            <i><b>/</b></i>
          </span>
        </div>
        <div
          style="position: absolute; left: 405px; top: 309px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '1' ? '' : 'd-none'"
          >
            {{ ForHotelOnly.TotalBaht }}
          </span>
        </div>
        <!-- End category 2 -->

        <!-- category 3 -->
        <div
          style="
            position: absolute;
            left: 132px;
            top: 332px;
            font-size: 10px;
            font-size: 18px !important;
          "
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '2' ? '' : 'd-none'"
          >
            <i><b>/</b></i>
          </span>
        </div>
        <div
          style="position: absolute; left: 405px; top: 358px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '2' ? '' : 'd-none'"
          >
            {{ ForHotelOnly.TotalBaht }}
          </span>
        </div>
        <!-- End category 3 -->

        <!-- category 4 -->
        <div
          style="
            position: absolute;
            left: 132px;
            top: 380px;
            font-size: 10px;
            font-size: 18px !important;
          "
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '3' ? '' : 'd-none'"
          >
            <i><b>/</b></i>
          </span>
        </div>
        <div
          style="position: absolute; left: 405px; top: 411px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '3' ? '' : 'd-none'"
          >
            {{ ForHotelOnly.TotalBaht }}
          </span>
        </div>
        <!-- End category 4 -->

        <!-- category 5 -->
        <div
          style="
            position: absolute;
            left: 132px;
            top: 428px;
            font-size: 10px;
            font-size: 18px !important;
          "
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '4' ? '' : 'd-none'"
          >
            <i><b>/</b></i>
          </span>
        </div>
        <div
          style="position: absolute; left: 405px; top: 459px; font-size: 10px"
          class="cls_005"
        >
          <span
            class="cls_005"
            :class="ForHotelOnly.Category == '4' ? '' : 'd-none'"
          >
            {{ ForHotelOnly.TotalBaht }}
          </span>
        </div>
        <!-- End category 5 -->
        <div
          style="position: absolute; left: 420px; top: 511px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ JoiningFeeRate }}</span>
        </div>
        <div
          style="position: absolute; left: 420px; top: 532px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ GrandTotal }}</span>
        </div>
        <div
          style="
            position: absolute;
            left: 200px;
            bottom: 212px;
            font-size: 10px;
          "
          class="cls_005"
        >
          <span class="cls_005">
            <img :src="AuthorisedSignature" height="50px" />
          </span>
        </div>
        <div
          style="position: absolute; left: 200px; top: 633px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ CapitalLetters.Name }}</span>
        </div>
        <div
          style="position: absolute; left: 370px; top: 633px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ CapitalLetters.Title }}</span>
        </div>
        <div
          style="position: absolute; left: 120px; top: 657px; font-size: 10px"
          class="cls_005"
        >
          <span class="cls_005">{{ CapitalLetters.Date }}</span>
        </div>
      </div>
    </div>
    <div id="pageload" style="z-index: 999" width="100%">
      <div class="bg-main">
        <img src="@/assets/images/loading.gif" width="100px" class="img-load" />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/maincss/bootstrap.min.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";
export default {
  name: "MembershipApplicationPdfview",
  data() {
    return {
      category: 1,
      pdfFile: null,
      formID: null,
      Organisation: null,
      Local: {
        Province: null,
        City: null,
        Address: null,
        Tel: null,
        Fax: null,
      },
      Bangkok: {
        Address: null,
        Tel: null,
        Fax: null,
      },
      Email: null,
      Website: null,
      Represented: {
        Name: null,
        Title: null,
        Tel: null,
        Fax: null,
        Email: null,
      },
      Alternate: {
        Name: null,
        Title: null,
        Tel: null,
        Fax: null,
        Email: null,
      },
      DescriptionServices: null,
      ExperienceMICE: null,
      OAMembership: null,
      OAMembershiplength: null,
      MembershipCategory: null,
      SubscriptionRate: null,
      ForHotelOnly: {
        NumberOfRooms: null,
        Category: [],
        TotalBaht: null,
      },
      AuthorisedSignature: null,
      CapitalLetters: {
        Name: null,
        Title: null,
        Date: null,
      },
      status: null,
      DocumentsNameA: null,
      DocumentsNameB: null,
      DocumentsNameC: null,
      DocumentsNameD: null,
      DocumentsNameE: null,
      DocumentsTypeA: null,
      DocumentsTypeB: null,
      DocumentsTypeC: null,
      DocumentsTypeD: null,
      DocumentsTypeE: null,
      RunningNumner: null,
      YearForGen: new Date().getFullYear(),
      JoiningFeeRate: 1500,
      GrandTotal: null,
      Province: [
        {
          id: 1,
          value: "Central",
          city: [
            { value: "Kanchanaburi" },
            { value: "Nakhonpathom" },
            { value: "Nonthaburi" },
            { value: "Pathumthani" },
            { value: "Phetchaburi" },
            { value: "Prachuap Khiri Khan" },
            { value: "Samutprakarn" },
          ],
        },
        {
          id: 2,
          value: "East",
          city: [
            { value: "Chanthaburi" },
            { value: "Chonburi" },
            { value: "Trat" },
            { value: "Prachinburi" },
            { value: "Rayong" },
          ],
        },
        {
          id: 3,
          value: "North",
          city: [{ value: "Chiang-Mai" }, { value: "Chiang-Rai" }],
        },
        {
          id: 4,
          value: "North-East",
          city: [
            { value: "Khon-Kaen" },
            { value: "Nakhon-Ratchasima" },
            { value: "Ubon-Ratchathani" },
            { value: "Udon-Thani" },
          ],
        },
        {
          id: 5,
          value: "South",
          city: [
            { value: "Krabi" },
            { value: "Phang-Nga" },
            { value: "Phuket" },
            { value: "Samui" },
            { value: "Songkhla" },
            { value: "Suratthani" },
            { value: "Trang" },
          ],
        },
        {
          id: 6,
          value: "Bangkok",
          city: [{ value: "Bangkok" }],
        },
      ],
    };
  },

  async mounted() {
    await this.setDataA();
    await this.makePDF();
    setTimeout(function () {
      window.location.href = "./thank-you";
    }, 10000);
  },

  methods: {
    async makePDF() {
      var DocA = this.DocumentsNameA;
      var DocB = this.DocumentsNameB;
      var DocC = this.DocumentsNameC;
      var DocD = this.DocumentsNameD;
      var DocE = this.DocumentsNameE;
      var DoctypeA = this.DocumentsTypeA;
      var DoctypeB = this.DocumentsTypeB;
      var DoctypeC = this.DocumentsTypeC;
      var DoctypeD = this.DocumentsTypeD;
      var DoctypeE = this.DocumentsTypeE;

      window.html2canvas = html2canvas;
      var doc = new jsPDF("p", "pt", "a4");
      await doc.html(document.querySelector("#pdfFile"), {
        callback: function () {
          var blob = doc.output("blob");
          const data = new FormData();
          data.append("document", blob, "pdfFile.pdf");
          data.append("documentA", DocA);
          data.append("documentB", DocB);
          data.append("documentC", DocC);
          data.append("documentD", DocD);
          data.append("documentE", DocE);
          data.append("documentTypeA", DoctypeA);
          data.append("documentTypeB", DoctypeB);
          data.append("documentTypeC", DoctypeC);
          data.append("documentTypeD", DoctypeD);
          data.append("documentTypeE", DoctypeE);
          var url =
            "https://www.tica.or.th/uploads/membership-application/save/";
          var header = { headers: { "Content-Type": "multipart/form-data" } };
          axios
            .post(url, data, header)
            .then((response) => console.log(response));
        },
      });
    },
    setDataA() {
      let data = JSON.parse(sessionStorage.getItem("membershipApplication"));
      this.RunningNumner =
        data.CapitalLettersDate.split("-").slice(0, -1).join("") +
        "-" +
        JSON.parse(sessionStorage.getItem("Appid"));
      console.log(data);
      this.Organisation = data.Organisation;
      // local address
      this.Local.Address =
        data.LocalAddress +
        ",  " +
        this.Province[data.LocalProvince - 1].value +
        ",  " +
        data.LocalCity;
      this.Local.Province = this.Province[data.LocalProvince - 1].value;
      this.Local.City = data.LocalCity;
      this.Local.Tel = data.LocalDirectNumber;
      this.Local.Fax = data.LocalMobile;
      this.Email = data.LocalEmail;
      this.Website = data.LocalWebsite;
      // Bangkok address
      this.BangkokAddNone = data.BangkokNone;
      this.Bangkok.Address = data.BangkokAddress;
      this.Bangkok.Tel = data.BangkokDirectNumber;
      this.Bangkok.Fax = data.BangkokMobile;
      //  Authorised by
      this.Represented.Name = data.AuthorisedName;
      this.Represented.Title = data.AuthorisedTitle;
      this.Represented.Tel = data.AuthorisedDirectNumber;
      this.Represented.Fax = data.AuthorisedMobile;
      this.Represented.Email = data.AuthorisedEmail;
      // Contact Person
      this.Alternate.Name = data.ContactPersonName;
      this.Alternate.Title = data.ContactPersonTitle;
      this.Alternate.Tel = data.ContactPersonDirectNumber;
      this.Alternate.Fax = data.ContactPersonMobile;
      this.Alternate.Email = data.ContactPersonEmail;
      //
      this.DescriptionServices = data.DescriptionOfServices;
      this.ExperienceMICE = data.ExperienceInMICEIndustry;
      this.OAMembership = data.MembershipOfOtherAssociation;
      this.OAMembershiplength = this.OAMembership.length;
      // Category
      this.MembershipCategory = data.MembershipCategory.name.name;
      this.SubscriptionRate = data.SubscriptionRateTHB;
      this.ForHotelOnly.NumberOfRooms = data.ForHotelOnlyNumberOfRooms;
      this.ForHotelOnly.Category = data.ForHotelOnlyCategory;
      this.ForHotelOnly.TotalBaht = data.ForHotelOnlyTotalBaht;
      // Authorised Signature
      this.CapitalLetters.Name = data.CapitalLettersName;
      this.CapitalLetters.Title = data.CapitalLettersTitle;
      this.CapitalLetters.Date = data.CapitalLettersDate;
      // files
      this.DocumentsNameA = data.LORF2TMDocuments.Newname;
      this.DocumentsNameB = data.COBRDocuments.Newname;
      this.DocumentsNameC = data.COBLDocuments.Newname;
      this.DocumentsNameD = data.COPPDocuments.Newname;
      this.DocumentsNameE = data.LORF2TM2Documents.Newname;
      // type
      this.DocumentsTypeA = data.LORF2TMDocuments.Type;
      this.DocumentsTypeB = data.COBRDocuments.Type;
      this.DocumentsTypeC = data.COBLDocuments.Type;
      this.DocumentsTypeD = data.COPPDocuments.Type;
      this.DocumentsTypeE = data.LORF2TM2Documents.Type;

      // Auth
      this.AuthorisedSignature = "https://" + data.AuthorisedSignature.url;

      this.GrandTotal =
        parseInt(this.SubscriptionRate) +
        parseInt(this.ForHotelOnly.TotalBaht) +
        this.JoiningFeeRate;

      // log
      console.log(this.DocumentsNameA + "." + this.DocumentsTypeA);
      console.log(this.DocumentsNameB + "." + this.DocumentsTypeB);
      console.log(this.DocumentsNameC + "." + this.DocumentsTypeC);
      console.log(this.DocumentsNameD + "." + this.DocumentsTypeD);
      console.log(this.DocumentsNameE + "." + this.DocumentsTypeE);
    },
  },
};
</script>
<style>
#pdfFile {
  text-align: left;
}
.text-headder-f {
  padding-left: 15rem;
}
.cls_005 {
  font-family: sans-serif;
  line-height: 1.8;
}
.d-none {
  display: none;
}
</style>
 <style  scoped>
/* Absolute Center Spinner */
.bg-main {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: block;
  width: 100%;
  height: 100%;
  background: -webkit-radial-gradient(rgba(151, 151, 151), rgba(151, 151, 151));
}
.img-load {
  position: fixed;
  top: 40%;
  left: 46%;
}
</style>

      